import {TRANSLATION, Yup} from '@/imports-files/pages/admins/dashboard/clients/new';

const URL_FORMAT = /^((http|https):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i;
const phoneRegex = /^\+?[\d\s]+$/;

export const INITIAL_VALUES = {
  client: {
    name: '',
    website: '',
    location_attributes: {
      full_address: '',
      place_id: '',
    },
    ai_access: true,
    super_account_owner_attributes: {
      user_attributes: {
        contact_no: '',
        email: '',
        name: '',
      },
   },
     client_branding_attributes:{ email_logo:'', logo:'', sidebar_logo: '', primary_color_hex:'', logo_branding: false, sidebar_logo_branding: false}

  },
};

export const VALIDATION_SCHEMA = Yup.object({
  client: Yup.object({
    name: Yup.string().required(TRANSLATION('common:errors:required')),
    website: Yup.string().matches(URL_FORMAT, TRANSLATION('page:admins:client:company:errors:website_url')),
    super_account_owner_attributes:
                                                    Yup.object({
                                                      user_attributes: Yup.object({
                                                        name: Yup.string().required(TRANSLATION('common:errors:required')),
                                                        contact_no: Yup.string()
                                                            .matches(phoneRegex, TRANSLATION('page:admins:client:company:errors:contact_no'))
                                                            .min(8, 'Contact No is too short (minimum is 8 characters)')
                                                            .max(20, 'Contact No is too long (maximum is 20 characters)').required(TRANSLATION('common:errors:required')),
                                                        email: Yup.string().email(TRANSLATION('common:errors:invalid_email')).required(TRANSLATION('common:errors:required')),
                                                      }),
                                                    }),
    location_attributes: Yup.object({
      full_address: Yup.string().required(TRANSLATION('common:errors:required')).nullable(true).test("validLocation", "Invalid address, Please select from the dropdown", function (value) {
        return this.parent.place_id && this.parent.place_id.length > 0
      })
    }),
    
  }),
});

export const CONSTANTS = {  brand_logo:{
                                        file_size:200,
                                        file_height:50,
                                        file_width: 184,
                                        dimension_error_message: 'The dimensions of the image should be greater than or equal to 184px X 50px',
                                        size_error_message: 'The file size of the image should be less than 200KB'
                                       },
                                    email_logo:{
                                       file_size:100,
                                       file_height:100,
                                       file_width: 365,
                                       dimension_error_message: 'The dimensions of the image should be greater than or equal to 365px X 100px',
                                       size_error_message: 'The file size of the image should be less than 100KB'
                                       },
                                    sidebar_logo:{
                                       file_size:200,
                                       file_height:100,
                                       file_width: 100,
                                       dimension_error_message: 'The dimensions of the image should be greater than or equal to 100px X 100px',
                                       size_error_message: 'The file size of the image should be less than 200KB'
                                       }
                            }
